import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import applyReducer from './applyReducer';
import constants from '../constants/settingsConstants';
const initState = {
  loaded: false,
  loading: false,
  settings: {}
};
const loadSettings = (state, _ref) => {
  let data = _ref.data;
  let settings = {};
  const _data = _slicedToArray(data, 1),
    customerSettings = _data[0];
  if (customerSettings) {
    settings = JSON.parse(customerSettings.json);
  }
  return {
    loaded: true,
    loading: false,
    settings
  };
};
const setLoading = state => _objectSpread(_objectSpread({}, state), {}, {
  loading: true
});
const reducers = {
  [constants.SETTINGS_LOAD_SUCCESS]: loadSettings,
  [constants.SETTINGS_LOADING]: setLoading
};
export default applyReducer(reducers, initState);